<!-- Mode Edit (!RO) -->

<!-- Mode Visu (RO) -->
<ion-item lines="none" *ngIf="params.readOnly" [ngClass]="params.cssClass ? params.cssClass : 'ion-no-padding'">
	<ion-label *ngIf="params.label">{{params.label}}</ion-label>
	<ion-icon *ngIf="params.icon && fieldValue" [name]="params.icon" class="margelect"></ion-icon>
	<ion-label>{{value | dateWithLocale : 'fr-FR' : params.displayFormat}}</ion-label>
</ion-item>